import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * The shadcn class merger: clsx for conditionals, twMerge to resolve Tailwind conflicts.
 *
 * twMerge MUST be told about the custom font-size utilities from theme.css. It only knows
 * Tailwind's stock scale (text-xs…text-9xl); an unknown `text-*` class is assumed to be a
 * text COLOR, so `text-tiny` + `text-text-secondary` looked like two colors in conflict and
 * the size class was silently deleted. Every ToneBadge pairs a custom size with a color, so
 * every badge in the app was rendering at the inherited body size — the bug is invisible in
 * the source and only shows up in the computed style.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-micro', 'text-tiny', 'text-md', 'text-kpi', 'text-hero'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
